/**
 * @desc 分页
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.salesOwnerInfo.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/salesOwnerInfo/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
